import type { RawParams } from "@uirouter/react";

import { TextAnchorCell } from "@similarweb/pro-logic-components";
import { Tooltip } from "@similarweb/ui-components";

import { EAdsTabs } from "app/components/React/PlaResearch/type";
import { SearchKeywordCell } from "app/components/React/Table/cells";
import { translate } from "app/filters/i18nFilter";
import { createMultiIncludeExcludeFilter } from "app/pages/website-analysis/traffic-sources/search/components/filters/MultiIncludeExclude/utils";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";
import { searchAdvertisingNavigation } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingNavigator";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import {
    DEFAULT_SORT,
    tabsMapping,
    getTableColumns as getOriginalTableColumns,
    getKeywordsDrilldownTableColumns as getOriginalKeywordsDrilldownTableColumns,
    adsDrilldownTableColumns,
} from "./OrganicLandingPagesColumnsConfigV2";

export { DEFAULT_SORT, tabsMapping, adsDrilldownTableColumns };

const SEARCH_TERM_COLUMN = "SearchTerm";

export const getTableColumns = (params: RawParams, setTabIndex: (index: number) => void) => {
    const columns = getOriginalTableColumns(params, setTabIndex);
    const currentParams = proNavigator.getParams();

    const onSearchTermClick = (value: string) => {
        void searchAdvertisingNavigation.keywords.go({
            ...currentParams,
            multiIncludeExcludeKeywords: createMultiIncludeExcludeFilter(value, "keyword"),
        });
    };

    return columns.map((col) => {
        if ("field" in col && col.field === SEARCH_TERM_COLUMN) {
            return {
                ...col,
                cellComponent: ({ value }: { value: string }) => {
                    return (
                        <Tooltip
                            content={translate("advertiser.activity.search.landing.pages.search.term.cell.tooltip")}
                        >
                            <TextAnchorCell onClick={() => onSearchTermClick(value)}>{value}</TextAnchorCell>
                        </Tooltip>
                    );
                },
            };
        }
        return col;
    });
};

export const getKeywordsDrilldownTableColumns = (
    pageParams: RawParams,
    sortField: string,
    sortDirection: string,
    _keywordTargetState: string,
    parentUrl?: string,
): ReturnType<typeof getOriginalKeywordsDrilldownTableColumns> => {
    const columns = getOriginalKeywordsDrilldownTableColumns(
        pageParams,
        sortField,
        sortDirection,
        ROUTES.keywords,
        parentUrl,
    );
    const currentParams = proNavigator.getParams();

    const getSearchAdsUrl = (value: string, url: string) => {
        return searchAdvertisingNavigation.textAndShoppingAds.getLink({
            ...currentParams,
            selectedPageTab: EAdsTabs[EAdsTabs.Text],
            multiIncludeExcludeUrl: createMultiIncludeExcludeFilter(url, "url"),
            multiIncludeExcludeKeywords: createMultiIncludeExcludeFilter(value, "keyword"),
        });
    };

    return columns.map((col) => {
        if ("field" in col && col.field === SEARCH_TERM_COLUMN) {
            return {
                ...col,
                cellComponent: ({ value }: { value: string }) => {
                    return (
                        <SearchKeywordCell
                            value={value}
                            adsUrl={getSearchAdsUrl(value, parentUrl || "")}
                            destinationState={ROUTES.keywords}
                            withGoogleLink
                            destinationStateParams={{
                                ...currentParams,
                                multiIncludeExcludeUrl: createMultiIncludeExcludeFilter(parentUrl || "", "url"),
                                multiIncludeExcludeKeywords: createMultiIncludeExcludeFilter(value, "keyword"),
                            }}
                        />
                    );
                },
            };
        }
        return col;
    }) as ReturnType<typeof getOriginalKeywordsDrilldownTableColumns>;
};
